import BasePage from '../../../../../components/table_page';
import request from '../../../../../utils/request';
import Form from './form';

export default {
  name: 'banquet_reward_configuration',
  extends: BasePage,
  data() {
    return {
      params: {
        awardType: 'cash',
      },
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
    },
  },
};
